import { Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';

export default class Resource<TResourceType> extends Vue {
    @Prop() public baseUrl!: string;

    protected toCamelCaseObject(resource: any): any {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        let newObject: any, origKey, newKey, value;
        if (resource instanceof Array) {
            return resource.map(function(value) {
                if (typeof value === 'object') {
                    value = self.toCamelCaseObject(value);
                }
                return value;
            });
        } else {
            newObject = {};
            for (origKey in resource) {
                // eslint-disable-next-line no-prototype-builtins
                if (resource.hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                    value = resource[origKey];
                    if (value instanceof Array || (value !== null && value.constructor === Object)) {
                        value = self.toCamelCaseObject(value);
                    }
                    newObject[newKey] = value;
                }
            }
        }
        return newObject;
    }

    protected toPascalCaseObject(resource: any): any {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        let newObject: any, origKey, newKey, value;
        if (resource instanceof Array) {
            return resource.map(function(value) {
                if (typeof value === 'object') {
                    value = self.toPascalCaseObject(value);
                }
                return value;
            });
        } else {
            newObject = {};
            for (origKey in resource) {
                // eslint-disable-next-line no-prototype-builtins
                if (resource.hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString();
                    value = resource[origKey];
                    if (value instanceof Array || (value !== null && value.constructor === Object)) {
                        value = self.toPascalCaseObject(value);
                    }
                    newObject[newKey] = value;
                }
            }
        }
        return newObject;
    }
}
